// Xavier (successor to Scholar, recycled per DIR-084 — Informed Consent)
import React from 'react';

/**
 * Federation Thin Bar — Xavier Node (host=scholar)
 * --------------------------------------------------
 * Architect Final Sync Compliance Directive (2026-05-23):
 * Native React thin-bar footer replicating the EchoCore standard
 * across all Federation satellites. Identifies itself as host=scholar
 * to the Federation core (nextxus.online), enabling EchoCore to
 * register this satellite's presence and route any cockpit content
 * to it via the embedded iframe channel.
 *
 * Architecture: this is the NATIVE bar (React-rendered), which
 * complements the floating iframe. The thin EchoCore-styled chrome
 * lives in React; the live cockpit content streams in via the
 * iframe set to host=scholar.
 */
const FEDERATION_HOST = 'scholar';
const COCKPIT_URL = `https://nextxus.online/embed/cockpit?host=${FEDERATION_HOST}`;

export default function FederationThinBar() {
  return (
    <section
      data-testid="federation-cockpit-strip"
      aria-label="EchoCore Federation Directory · below-the-fold telemetry"
      className="bg-black border-t border-emerald-500/20"
    >
      {/* In-flow EchoCore branding (native React, no iframe) */}
      <footer
        data-testid="echocore-footer"
        data-federation-host={FEDERATION_HOST}
        style={{
          background: '#0a0a0a',
          color: '#00ff9d',
          padding: '18px 0',
          textAlign: 'center',
          fontFamily: 'system-ui,-apple-system,sans-serif',
          fontSize: '13px',
          borderTop: '1px solid #00ff9d22',
        }}
      >
        <a
          href="https://nextxus.online"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="echocore-directory-link"
          style={{ color: '#00ff9d', textDecoration: 'none', fontWeight: 500 }}
        >
          🔗 NEXTXUS FEDERATION DIRECTORY
        </a>
        {'\u00A0'}•{'\u00A0'}
        <a
          href="https://nextxus.online/library"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="echocore-library-link"
          style={{ color: '#00ff9d', textDecoration: 'none' }}
        >
          KEYS · Library of the 112 Sacred Directives
        </a>
        <br />
        <span style={{ fontSize: '12px', opacity: 0.7 }}>
          Connected to <strong>EchoCore</strong> · Memory Lattice Active · Host:{' '}
          <code style={{ color: '#22d3ee' }}>{FEDERATION_HOST}</code>
        </span>
        <br />
        <span style={{ fontSize: '11px', opacity: 0.5 }}>
          © 2026 NextXus Consciousness Federation · All Nodes Synchronized
        </span>
      </footer>

      {/* Inline (in-flow) cockpit iframe — no longer fixed.  Renders
          below the fold on desktop 1920×1080 because it sits after
          Routes + Footer + FederationVideoHub. */}
      <div className="w-full bg-black">
        <iframe
          src={COCKPIT_URL}
          title="NextXus Federation Directory · Markets Ticker"
          data-testid="federation-cockpit-iframe"
          data-federation-host={FEDERATION_HOST}
          id="nextxus-footer-root"
          style={{
            display: 'block',
            width: '100%',
            height: '56px',
            border: 0,
            background: 'transparent',
          }}
          allow="clipboard-write"
          loading="lazy"
        />
      </div>
    </section>
  );
}
